import { FormGroup } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-factory-core',
  templateUrl: './form-factory-core.component.html',
})
export class FormFactoryCoreComponent {
  /**
   * @description
   * This component is part of form-builder component.
   * Here it is checked which type of form control is and that type is displayed.
   */

  /**
   * * Inputs
   * @field Configuration for form filed
   * @form This is locale form for one language
   * @mainForm This is main FormGroup
   */
  @Input() field: any;
  @Input() form: FormGroup;
  @Input() mainForm: FormGroup;
  @Input() langCode!: string;
}
